import React from 'react';
import BusinessInNumbersSlider from './BusinessInNumbersSlider';

const BusinessInNumbers = ({ color }) => {
  return (
    <div className="bg-white md:bg-[#F5F5F5] overflow-hidden">
      <div className="py-[48px]">
        <div className="flex gap-[48px] flex-col ">
          <div className="container">
            <h2 className="flex justify-center items-center font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px] text-black">
              Our Business in Numbers
            </h2>
          </div>
          <div className="max-w-[1668px] mx-auto">
            <BusinessInNumbersSlider color={color} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessInNumbers;
